import type { FC } from 'react';
import { StatusInfo } from '@george-labs.com/design-system';

import { Translation, t } from '@luna/i18n';

export const UnknownError: FC = () => (
    <StatusInfo
        preferIllustration
        data-cy="unknown-error"
        variant={StatusInfo.VARIANT.ERROR}
        title={t('errorBoundary.unknownErrorTitle')}
    >
        <Translation t="errorBoundary.unknownErrorDescription" />
    </StatusInfo>
);
